import { useCallback } from 'react';

import { STICKY_PAGE_ACTIONS_EVENTS } from '../constants';
import {
    ActionItem,
    RegisterEventData,
    RemoveEventData,
    ToggleVisibleEventData,
    UpdateBadgeCountEventData,
    UpdateBottomOffsetEventData,
} from '../model';

export const useStickyPageActions = () => {
    const registerAction = useCallback((action: ActionItem) => {
        const event = new CustomEvent<RegisterEventData>(STICKY_PAGE_ACTIONS_EVENTS.REGISTER_ACTION, {
            detail: { action },
        });
        window.dispatchEvent(event);
    }, []);

    const removeAction = useCallback((actionId: string) => {
        const event = new CustomEvent<RemoveEventData>(STICKY_PAGE_ACTIONS_EVENTS.REMOVE_ACTION, {
            detail: { actionId },
        });
        window.dispatchEvent(event);
    }, []);

    const toggleVisibleAction = useCallback((actionId: string, isVisible: boolean) => {
        const event = new CustomEvent<ToggleVisibleEventData>(STICKY_PAGE_ACTIONS_EVENTS.TOGGLE_VISIBLE, {
            detail: { actionId, isVisible },
        });
        window.dispatchEvent(event);
    }, []);

    const updateBadgeCountAction = useCallback((actionId: string, count?: number) => {
        const event = new CustomEvent<UpdateBadgeCountEventData>(STICKY_PAGE_ACTIONS_EVENTS.UPDATE_BADGE_COUNT, {
            detail: { actionId, count },
        });
        window.dispatchEvent(event);
    }, []);

    const updateBottomOffset = useCallback((offset: string) => {
        const event = new CustomEvent<UpdateBottomOffsetEventData>(STICKY_PAGE_ACTIONS_EVENTS.UPDATE_BOTTOM_OFFSET, {
            detail: { offset },
        });
        window.dispatchEvent(event);
    }, []);

    return { registerAction, removeAction, toggleVisibleAction, updateBadgeCountAction, updateBottomOffset };
};
